import React from 'react'
import { Html5QrcodeScanner, Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode"

import MyButton from '../UI/form/MyButton'
import MyModal from '../UI/modal/MyModal'
import { useDispatch, useSelector } from "react-redux";
import { setScannerActivate, setScannerOpen, setScannerResult, setScannerType } from '../../store/scannerSlice'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import ScannerWindow from './ScannerWindow';
import ScannerWindowPro from './ScannerWindowPro';
import { useEffect } from 'react';

const ScannerQR = ({ buttonText, onClickOpen, onClickClose, isCameraOnly }) => {

	const open = useSelector(state => state.scanner.open)
	const type = useSelector(state => state.scanner.type)
	const scanTypeUser = useSelector(state => state.user.user.scanType)
    const activate = useSelector(state => state.scanner.activate)
	const result = useSelector(state => state.scanner.result)
	const dispatch = useDispatch()

	useEffect(() => {
        // Примусове відкриття потрібного сканеру, якщо є в налаштуваннях у користувача
        if (scanTypeUser && activate && !isCameraOnly) {
            if (scanTypeUser === 'camera') {
                openScanner()
            }
        }
    }, [activate, scanTypeUser])

	const openScanner = (e) => {
		if (!open) { // Відкривати новий сканер лише якщо не відкритий інший
			if (onClickOpen) {
				onClickOpen(e)
			}
			dispatch(setScannerType('camera'))
			dispatch(setScannerOpen(true))
		}
	}

  return (
	<>
		{/* {
			result ?
				<div>
					{ result }
				</div>
			: ''
		} */}
		{
			scanTypeUser && scanTypeUser === 'hid' && !isCameraOnly ? '' 
			:
			<MyButton
				onClick={e => openScanner(e)}
			>
				{
					buttonText ? buttonText : <QrCodeScannerIcon />
				}
				камера пристрою
			</MyButton>
		}

        <MyModal
            open={open && type && type === 'camera'}
            setOpen={e => {
				if (onClickClose) {
					onClickClose(e)
				}
				dispatch(setScannerOpen(e))
			}}
            header={'Сканер QR (штрих) кодів'}
            disableClickOutside={true}
            content={
                // <ScannerWindow />
                <ScannerWindowPro />
            }
        />
    </>
  )
}

export default ScannerQR